import styled, { css } from 'styled-components';
import { BaSeTheme } from '@base/react';

export const CardStyled = styled.div`
  min-height: 390px;
  width: 290px;
  border-radius: 4px;
  background-color: ${BaSeTheme.colors.defaultColors.white};
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  border-left: 4px solid ${BaSeTheme.colors.gestao.cinza67};
  box-shadow: ${BaSeTheme.shadows.profundidade2};
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 152px 32px auto;
  @media screen and (max-width: ${BaSeTheme.breakpoints.mobileLarge
      .maxWidth}px) {
    width: 100%;
  }
`;

export const CardImage = styled.div`
  ${({ image }) => css`
    background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae90};
    border-right: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
    border-top-right-radius: 4px;
    width: 100%;
    background-image: url(${image});
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
  `};
`;

export const SpanDataInfo = styled.div`
  background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae97};
  display: flex;
  gap: 13.33px;
  align-items: center;
  padding: 0 12.67px;
  small {
    display: flex;
    align-items: center;
  }
  img {
    margin-right: 2px;
  }
`;

export const CardBody = styled.div`
  padding: 12px 14px 24px 20px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  button {
    align-self: flex-start;
  }
`;

export const CardBodyText = styled.div`
  padding: 16px 10px 0 0;
`;

export const WrapperButton = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const WrapperShared = styled.div`
  display: flex;
  gap: 10px;
  margin: 10px 0;
`;
